import {create} from "zustand";
import { AdminNotificationsListItemResponseDto, NotificationCategory, NotificationType } from '@/features/notifications/types/notifications-dto';

const DEFAULT_PAGE_SIZE = 10;

type NotificationsFilterType = {
    filter: {
        take: number;
        skip?: number;
        orderBy?: Capitalize<keyof AdminNotificationsListItemResponseDto> | null;
        orderDirection: 'asc' | 'desc';
        startDate?: Date | null;
        endDate?: Date | null;
        type?: NotificationType | null;
        category?: NotificationCategory | null;
    },
    setFilter: ( filter: Partial<NotificationsFilterType['filter']> ) => void;
    resetFilter: () => void;
};

const defaultState: NotificationsFilterType['filter'] = {
    take: DEFAULT_PAGE_SIZE,
    skip: 0, 
    orderBy: null, 
    orderDirection: 'asc', 
    startDate: null,
    endDate: null,
    type: null, 
    category: null
};

export const useNotificationsFilter = create<NotificationsFilterType>((set) => ({
    filter: {...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ 
            filter: {...defaultState },
        });
    },
}));